import { gql } from "@apollo/client";
import { GUIDE_EDITOR_JOB_ROLE_GUIDE_TEMPLATE_STAGE_SCHEDULER_CONFIG_FRAGMENT } from "components/GuideEditor/types/JobRoleGuideTemplate";

export const JOB_ROLE_GUIDE_TEMPLATE_FOR_PREVIEW_FRAGMENT = gql`
  fragment JobRoleGuideTemplateForPreviewFragment on JobRoleGuideTemplate {
    id
    jobDisplayName
    interviewProcessEnabled
    jobRoleGuideTemplateStages {
      id
      name
      description
      position
      atssyncJobStage {
        id
        originalATSId
      }
      schedulerConfig {
        ...GuideEditorJobRoleGuideTemplateStageSchedulerConfigFragment
      }
      contentTemplate {
        id
        name
        modulesInflated {
          id
          type
          position
          data
        }
      }
    }
  }
  ${GUIDE_EDITOR_JOB_ROLE_GUIDE_TEMPLATE_STAGE_SCHEDULER_CONFIG_FRAGMENT}
`;

export const GUIDE_TEMPLATE_FOR_PREVIEW_FRAGMENT = gql`
  fragment GuideTemplateForPreviewFragment on GuideTemplate {
    id
    chatEnabled
    isGlobal
    department {
      id
      name
    }
    interviewProcessEnabled
    guideBanner
    guideContent
    guideTemplateStages {
      id
      name
      description
      position
      contentTemplate {
        id
        name
        modulesInflated {
          id
          type
          position
          data
        }
      }
    }
    updatedAt
  }
`;

export const PREVIEW_GUIDE_ORGANIZATION_FRAGMENT = gql`
  fragment PreviewGuideOrganizationFragment on Organization {
    id
    companyLogoUrl
    name
    theme {
      primaryColor
      secondaryColor
    }
    showTrim
  }
`;
